import { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import EsfirusButtonNative from "@components/ui/Button/EsfirusButtonNative";
import "./GeneralModalError.scss";

const MSG_ERROR_DEFAULT = "Inténtelo más tarde y si persiste el error, póngase en contacto con su administrador."

const GeneralModalError = () => {
  const [error, setError] = useState<boolean>(false)
  const [msgError, setMsgError] = useState<string>("")
  const [url, setUrl] = useState<string>("")

  const handlerError = (e: any) => {
    const messageError = e.detail.messageError as string
    const url = e.detail.url as string

    setMsgError(messageError)
    setUrl(url)
    setError(true)
  }

  useEffect(() => {
    document.addEventListener("generalerror", handlerError)

    return () => {
      document.removeEventListener("generalerror", handlerError)
    }
  }, [])

  if (!error) return <></>

  return (
    <Modal
      open={error}
      onClose={() => setError(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="general-modal-error">
        <div className="header">
          <div className="url-modal-error">{url}</div>
          <h5 className="text-center">
            Algo ha salido mal
          </h5>
        </div>
        <div className="body">
          <div className="text-center ph-30">{msgError || MSG_ERROR_DEFAULT}</div>
          <div className="button-container">
            <EsfirusButtonNative
              click={() => setError(false)}
              label="Aceptar"
            ></EsfirusButtonNative>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default GeneralModalError